import { render, staticRenderFns } from "./dataEscrow.vue?vue&type=template&id=3aa7f81b&scoped=true"
import script from "./dataEscrow.vue?vue&type=script&lang=js"
export * from "./dataEscrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa7f81b",
  null
  
)

export default component.exports